class Nav {
    constructor() {
    }

    static init() {
        const activeClass: string = "active";
        const navCatLinks: NodeListOf<HTMLLinkElement> = document.querySelectorAll(".js-nav-sub-lk");
        const navOpeners: NodeListOf<HTMLElement> = document.querySelectorAll(".js-nav-opn");
        const overlay: HTMLDivElement = document.querySelector(".js-overlay");
        const burger: HTMLDivElement = document.querySelector(".js-burger");

        navCatLinks!.forEach((lnk: HTMLElement) => {
            lnk.addEventListener("click", (event: MouseEvent) => {
                event.preventDefault();
                event.stopPropagation();
                navCatLinks!.forEach((lk: HTMLElement) => {
                    lk.classList.remove(activeClass);
                });

                lnk.classList.add(activeClass);

                const cat: HTMLDivElement = lnk.closest(".js-nav-sub");
                const pnls: NodeListOf<HTMLDivElement> = cat.querySelectorAll("[data-tg]");
                const targetPanelId = lnk.dataset.tgId;

                pnls.forEach((pnl: HTMLDivElement) => {
                    if (pnl.dataset.tg === targetPanelId) {
                        pnl.classList.add(activeClass);
                    }
                    else {
                        pnl.classList.remove(activeClass);
                    }
                });
            });
        });

        navOpeners!.forEach((ele: HTMLElement) => {
            ele.addEventListener("click", () => {
                const isActive: boolean = ele.classList.contains(activeClass);

                navOpeners.forEach((opn: HTMLElement) => {
                    opn.classList.remove(activeClass);
                });

                if (!isActive) {
                    ele.classList.add(activeClass);
                    overlay.classList.add(activeClass);
                }
                else {
                    overlay.classList.remove(activeClass);
                }
            });
        });

        overlay.addEventListener("click", () => {
            navOpeners.forEach((opn: HTMLElement) => {
                opn.classList.remove(activeClass);
            });

            overlay.classList.remove(activeClass);            
        });

        burger.addEventListener("click", () => {
            document.getElementById('mn').classList.toggle('mn-active');
            document.getElementById('ha').classList.toggle('ha-active');

            navOpeners.forEach((opn: HTMLElement) => {
                opn.classList.remove(activeClass);
            });

            overlay.classList.remove(activeClass);
        });
    }
}

export default Nav;